<template>
  <div>
    <h3>道具订单</h3>
    <el-form :inline="true" class="demo-form-inline" :loading="loading" size="mini">
      <el-form-item label="账号 ID">
        <el-input placeholder="账号 ID" v-model="queryParams.userId"></el-input>
      </el-form-item>
      <el-form-item label="用户手机号">
        <el-input placeholder="用户手机号" v-model="queryParams.phoneNumber"></el-input>
      </el-form-item>
      <el-form-item label="道具ID">
        <el-input placeholder="道具ID" v-model="queryParams.orderId"></el-input>
      </el-form-item>
      <el-form-item label="道具名称">
        <el-input placeholder="道具名称" v-model="queryParams.orderName"></el-input>
      </el-form-item>
      <el-form-item label="权益ID">
        <el-input placeholder="权益ID" v-model.number="queryParams.equitiesId"></el-input>
      </el-form-item>
      <el-form-item label="权益名称">
        <el-input placeholder="权益名称" v-model="queryParams.equitiesName"></el-input>
      </el-form-item>
      <el-form-item label="道具包状态">
        <el-select v-model="queryParams.status">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(label, key) in propStatusFilterMap" :key="key" :label="label" :value="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="道具状态">
        <el-select v-model="queryParams.orderStatus">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(label, key) in propStatusFilterMap" :key="key" :label="label" :value="Number(key)"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="道具">
        <el-select v-model="queryParams.equitiesTypeDetail">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(label, key) in map.prop.types" :key="key" :label="label" :value="key"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="道具包来源">
        <el-select v-model="queryParams.equitiesGrundlagen">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(label, key) in map.prop.getTypes" :key="key" :label="label" :value="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单创建者身份">
        <el-select v-model="queryParams.sourcesRole">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(label, key) in map.prop.sourcesRole" :key="key" :label="label" :value="Number(key)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间从">
        <el-date-picker v-model="queryParams.createTimeStart" type="datetime" placeholder="开始时间"
          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="queryParams.createTimeEnd" type="datetime" placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="search">查询</el-button>
        <el-button type="primary" size="mini" @click="rest">重置</el-button>
        <!-- <el-button type="primary" size="mini" @click="exportExcel">导出</el-button> -->
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini">
      <!-- <el-table-column prop="index" label="序号">
        <template slot-scope="scope">{{ scope.$index+1}}</template>
      </el-table-column> -->
      <el-table-column prop="orderId" label="道具ID" width="150"></el-table-column>
      <el-table-column prop="orderName" label="道具名称" width="200"></el-table-column>
      <el-table-column prop="id" label="权益ID" width="150"></el-table-column>
      <el-table-column prop="equitiesName" label="权益名称" width="200"></el-table-column>
      <el-table-column prop="userId" label="账号 ID"></el-table-column>
      <el-table-column prop="phoneNumber" label="用户手机号" width="100"></el-table-column>
      <el-table-column prop="nickname" label="用户姓名" width="150"></el-table-column>
      <el-table-column prop="orderStatus" label="道具状态">
        <template slot-scope="scope">{{ map.prop.status[scope.row.orderStatus] || '-' }}</template>
      </el-table-column>
      <el-table-column prop="status" label="道具包状态">
        <template slot-scope="scope">{{ map.prop.status[scope.row.status] }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="订单创建时间"></el-table-column>
      <el-table-column prop="equitiesId" label="道具包 ID"></el-table-column>
      <!-- <el-table-column prop="equitiesTypeDetail" label="道具">
        <template slot-scope="scope">{{ map.prop.types[scope.row.equitiesTypeDetail] }}</template>
      </el-table-column> -->
      <el-table-column prop="totalNum" label="道具数量"></el-table-column>
      <el-table-column prop="equitiesGrundlagen" label="道具包来源">
        <template slot-scope="scope">{{ map.prop.getTypes[scope.row.equitiesGrundlagen] }}</template>
      </el-table-column>
      <el-table-column prop="operator" label="订单创建者昵称"></el-table-column>
      <el-table-column prop="sourcesRole" label="订单创建者身份">
        <template slot-scope="scope">{{ map.prop.sourcesRole[scope.row.sourcesRole]}}</template>
      </el-table-column>
      <el-table-column prop="useTime" label="道具包生效时间"></el-table-column>
      <el-table-column prop="overdueTime" label="道具包到期时间"></el-table-column>
      <el-table-column prop="equitiesUsedNum" label="道具已使用"></el-table-column>
      <el-table-column prop="equitiesSurplusNum" label="道具未使用"></el-table-column>
      <el-table-column label="操作" header-align="center" width="200px" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="handelChange(scope.row)">查看记录</el-button>
          <el-button size="mini" type="primary" @click="handleRefund(scope.row)">退款</el-button>
        </template>
      </el-table-column>

    </el-table>
    <br />
    <div>
      <el-pagination background layout="prev, pager, next" :current-page="queryParams.pageNum" :page-size="queryParams.limit" @current-change="currentChange"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="使用记录" :visible.sync="dialogVisible" :close-on-click-modal="false" :before-close="close" width="80%">
      <daily :iscom="true" :eqId="eqId" v-if="dialogVisible"></daily>
    </el-dialog>
    <el-dialog title="退款" :visible.sync="refundDialogVisible" :close-on-click-modal="false" :before-close="closeRefund" width="600px">
      <div class="refund-confirm">
        <el-form label-width="100px" size="mini">
          <el-form-item label="订单ID">
            <el-input :value="refundData.orderId" disabled></el-input>
          </el-form-item>
          <el-form-item label="订单名称">
            <el-input :value="refundData.title" disabled></el-input>
          </el-form-item>
          <el-form-item label="用户ID">
            <el-input :value="refundData.userId" disabled></el-input>
          </el-form-item>
          <el-form-item label="订单当前状态">
            <el-input :value="map.prop.status[refundData.status]" disabled></el-input>
          </el-form-item>
          <el-form-item label="付款金额">
            <el-input :value="'￥' + refundData.amount" disabled></el-input>
          </el-form-item>
        </el-form>
        <el-form :model="refundForm" :rules="refundRules" ref="refundForm" label-width="100px" size="mini">
          <el-form-item label="应退金额" prop="amount">
            <el-input
              v-model.trim="refundForm.amount"
              placeholder="请输入应退金额"
            ></el-input>
          </el-form-item>
          <el-form-item label="退款原因" prop="reason">
            <el-input
              type="textarea"
              v-model.trim="refundForm.reason"
              placeholder="请输入退款原因，最少 5 字，最多 200 字"
              :rows="5"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeRefund">取消</el-button>
        <el-button type="primary" @click="submitRefund">提交退款</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import map from "../../../datamap";
import api from "../../api";
import daily from "./daily.vue";
let { prop } = api;
export default {
  name: "partyBorder",
  components:{
    daily
  },
  data() {
    return {
      map,
      propStatusFilterMap: {
        1: map.prop.status[1],
        3: map.prop.status[3],
        5: map.prop.status[5],
        6: map.prop.status[6],
      },
      loading: true,
      queryParams: {
        pageNum: 1,
        limit: 30,
        role: 2,
        userId: '',
        status: '',
        orderStatus: '',
        equitiesName: '',
        phoneNumber: '',
        equitiesTypeDetail: '',
        equitiesGrundlagen: '',
        createTimeStart: '',
        createTimeEnd: '',
        equitiesId: '',
        sourcesRole: '',
        orderId: '',
        orderName: '',
      },
      eqId:'',
      list: [],
      dialogVisible: false,
      refundDialogVisible: false,
      refundData: {},
      refundForm: {
        orderId: '',
        amount: '',
        reason: '',
      },
      refundRules: {
        amount: [
          { required: true, message: '请输入实退金额', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const amount = Number(value);
              const refundableAmount = Number(this.refundData.amount);
              if (value === '' || Number.isNaN(amount)) {
                callback(new Error('实退金额必须为数字'));
              } else if (amount <= 0) {
                callback(new Error('实退金额必须大于 0'));
              } else if (amount > refundableAmount) {
                callback(new Error('实退金额不能大于应退金额'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        reason: [
          { required: true, message: '请输入退款原因', trigger: 'blur' },
          { min: 5, max: 200, message: '退款原因最少 5 字，最多 200 字', trigger: 'blur' },
        ],
      },
      total: 0,
    };
  },
  methods: {
    search() {
      this.queryParams.pageNum = 1;
      this.fetch();
    },
    rest(){
      this.queryParams={
        pageNum: 1,
        limit: 30,
        role: 2,
        userId: '',
        status: '',
        orderStatus: '',
        equitiesName: '',
        phoneNumber: '',
        equitiesTypeDetail: '',
        equitiesGrundlagen: '',       
        createTimeStart: '',
        createTimeEnd: '',
        equitiesId: '',
        sourcesRole: '',
        orderId: '',
        orderName: '',
      };
      this.fetch(); 
    },
    async fetch() {
      let res = await prop.qryPropOrder(this.queryParams);
      this.list = res.data.data;
      this.total = res.data.pageinfo.totalCount;
    },
    currentChange(e) {
      this.queryParams.pageNum = e;
      this.fetch();
    },
    handelChange(row) {
      console.log(row)
      this.eqId=row.id
      this.dialogVisible = true;
    },
    async handleRefund(row) {
      if (!row.orderId) {
        this.$message.warning('未找到该道具的订单号');
        return;
      }
      const res = await prop.order({ orderId: row.orderId });
      this.refundData = res.data.data;
      this.refundForm.orderId = row.orderId;
      this.refundDialogVisible = true;
    },
    submitRefund() {
      this.$refs.refundForm.validate(async (valid) => {
        if (!valid) return;
        await prop.commitRefund(this.refundForm);
        this.closeRefund();
        this.fetch();
      });
    },
    close() {
      this.dialogVisible = false;
    },
    closeRefund() {
      this.refundDialogVisible = false;
      this.refundData = {};
      this.refundForm = {
        orderId: '',
        amount: '',
        reason: '',
      };
      this.$nextTick(() => {
        this.$refs.refundForm && this.$refs.refundForm.clearValidate();
      });
    },
  },
  mounted() {

    this.search()
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/prop/partyB/order.vue